import { NgModule } from '@angular/core';
import { IMapaComponent } from './i-mapa/i-mapa';
import { PopoverTemplateComponent } from './popover-template/popover-template';
import { IonicModule } from 'ionic-angular';
import { RecaptchaModule } from 'ng-recaptcha';
import { UserProvider } from '../../providers/user';
import { ReservesProvider } from '../../providers/reserves';

@NgModule({
    declarations: [
        IMapaComponent,
        PopoverTemplateComponent
    ],
    imports: [
        IonicModule,
        RecaptchaModule
    ],
    exports: [
        IMapaComponent,
        PopoverTemplateComponent
    ],
    entryComponents: [
        PopoverTemplateComponent
    ],
    providers: [
        ReservesProvider,
        UserProvider
    ]
})
export class MapComponentsModule {  }


// WEBPACK FOOTER //
// ./src/components/mapa/map-components.module.ts